import { useAppName } from '@client-info/routes/delete-account/-hooks';
import {
  formatDocumentTitle,
  setDocumentTitle,
} from '@client-info/utils/branding';
import { useEffect } from 'react';

export const useDocumentTitle = (pageTitle?: string) => {
  const { appName } = useAppName();

  useEffect(() => {
    setDocumentTitle(formatDocumentTitle(appName, pageTitle));
  }, [pageTitle, appName]);
};
